/* =============================================================
 * SicilyAddict - Sticky Add To Cart (solo mobile)
 * -------------------------------------------------------------
 * Non sostituisce il product form nativo di Warehouse: rispecchia
 * il suo stato e inoltra il click al pulsante originale, cosi'
 * varianti, quantita', disponibilita', sconti automatici e
 * Rebuy Smart Cart continuano a funzionare come prima.
 *
 * Il form e il pulsante nativi vengono riletti a ogni uso: al cambio
 * variante Warehouse sostituisce .product-form__payment-container
 * (e con i combined listing l'intero form), quindi un riferimento
 * salvato al caricamento resterebbe staccato dal DOM. (audit PDP-01)
 * ============================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-sa-sticky-atc]');
  if (!root) return;

  function getForm() {
    return document.querySelector('form[id^="product-form-main"][action*="/cart/add"]')
        || document.querySelector('form.product-form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');
  }

  function getNativeBtn() {
    var f = getForm();
    return f ? f.querySelector('.product-form__add-button') : null;
  }

  function getSentinel() {
    var f = getForm();
    return f ? (f.querySelector('.product-form__buy-buttons') || f.querySelector('.product-form__add-button')) : null;
  }

  var initialForm = getForm();
  if (!initialForm || !getNativeBtn()) return;

  var elName  = root.querySelector('[data-sa-name]');
  var elMeta  = root.querySelector('[data-sa-meta]');
  var elPrice = root.querySelector('[data-sa-price]');
  var elBtn   = root.querySelector('[data-sa-btn]');
  var elQty   = root.querySelector('[data-sa-qty]');
  var elQIn   = root.querySelector('[data-sa-qty-input]');
  var labels  = (window.languages || {});

  document.body.classList.add('sa-has-sticky-atc');

  /* ---------- formattazione prezzo ------------------------- */
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var fmt = (window.theme && window.theme.moneyFormat) || '&euro;{{amount_with_comma_separator}}';
    var value = cents / 100;
    function withComma(n) {
      return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
    }
    function withPeriod(n) {
      return n.toFixed(2);
    }
    var out = fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(value))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(value))
      .replace(/\{\{\s*amount\s*\}\}/g, withPeriod(value))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withPeriod(value));
    /* il money format puo' contenere entita' HTML tipo &euro; */
    var tmp = document.createElement('textarea');
    tmp.innerHTML = out;
    return tmp.value.replace(/<[^>]*>/g, '').trim();
  }

  /* ---------- lettura stato dal DOM nativo ----------------- */
  function cleanText(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .visually-hidden--inline, [aria-hidden="true"]').forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function readPriceFromDom() {
    var node = document.querySelector('.product-meta .price-list .price--highlight')
            || document.querySelector('.product-meta .price-list .price')
            || document.querySelector('.product-form .price-list .price--highlight')
            || document.querySelector('.product-form .price-list .price');
    return cleanText(node);
  }

  function readVariantLabel() {
    var form = getForm();
    if (!form) return '';
    var parts = [];
    form.querySelectorAll('.product-form__option-selector, .block-swatch-list, .variant-selector').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) {
        var lbl = checked.id ? group.querySelector('label[for="' + checked.id + '"]') : null;
        /* solo il testo del pulsante (etichetta breve), senza badge tipo "Convenienza" */
        var txt = lbl && lbl.querySelector('.block-swatch__item-text');
        if (lbl) parts.push(cleanText(txt || lbl));
        else if (checked.value) parts.push(String(checked.value).trim());
      }
    });
    form.querySelectorAll('select[name^="options"]').forEach(function (sel) {
      if (sel.value) parts.push(sel.value.trim());
    });
    return parts.filter(Boolean).join(' · ');
  }

  /* ---------- quantita' (rispecchia il selettore della scheda) ---------- */
  function nativeQty() {
    var f = getForm();
    return f ? f.querySelector('input.quantity-selector__value[name="quantity"], input[name="quantity"]') : null;
  }
  function clampQty(v) { return Math.max(1, parseInt(v, 10) || 1); }
  function setQty(v) {
    v = clampQty(v);
    if (elQIn && String(elQIn.value) !== String(v)) elQIn.value = v;
    var n = nativeQty();
    if (n && String(n.value) !== String(v)) {
      n.value = v;
      n.dispatchEvent(new Event('input', { bubbles: true }));
      n.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function syncQty() {
    if (!elQty) return;
    var n = nativeQty();
    if (!n) { elQty.hidden = true; return; }
    elQty.hidden = false;
    if (document.activeElement !== elQIn) {
      var v = String(clampQty(n.value));
      if (elQIn.value !== v) elQIn.value = v;
    }
  }
  if (elQty) {
    root.querySelector('[data-sa-qty-minus]').addEventListener('click', function () { setQty(clampQty(elQIn.value) - 1); });
    root.querySelector('[data-sa-qty-plus]').addEventListener('click', function () { setQty(clampQty(elQIn.value) + 1); });
    elQIn.addEventListener('change', function () { setQty(elQIn.value); });
    elQIn.addEventListener('blur', function () { setQty(elQIn.value); });
  }
  /* il cliente cambia la quantita' nella scheda: la barra si aggiorna */
  document.addEventListener('input', function (e) { if (e.target === nativeQty()) syncQty(); });

  function setLoading(on) {
    elBtn.classList.toggle('is-loading', on);
    elBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* Il pulsante nativo ha due etichette (lunga per desktop, corta "Aggiungi" per mobile):
     la barra fissa e' solo mobile, quindi usa quella corta e lascia spazio a nome e formato. */
  function nativeLabel(btn) {
    if (!btn) return '';
    var shortLabel = btn.querySelector('.sa-atc-label--short');
    var longLabel = btn.querySelector('.sa-atc-label--long');
    return cleanText(shortLabel) || cleanText(longLabel) || cleanText(btn);
  }

  function syncAvailability() {
    var btn = getNativeBtn();
    var disabled = !btn || btn.hasAttribute('disabled') || btn.classList.contains('button--disabled');
    var text = disabled
      ? (labels.productFormSoldOut || 'Non disponibile')
      : (nativeLabel(btn) || labels.productFormAddToCart || 'Aggiungi al carrello');
    if (elBtn.disabled !== disabled) elBtn.disabled = disabled;
    if (!elBtn.classList.contains('is-loading') && elBtn.textContent !== text) elBtn.textContent = text;
  }

  function sync(variant) {
    if (variant && typeof variant.price === 'number') {
      elPrice.textContent = formatMoney(variant.price);
    } else {
      var dom = readPriceFromDom();
      if (dom) elPrice.textContent = dom;
    }

    /* prima le etichette mostrate sui pulsanti (es. "15 grandi · Classica"), poi il nome della variante */
    var label = readVariantLabel() ||
      ((variant && variant.title && variant.title !== 'Default Title') ? variant.title : '');

    if (label) {
      elMeta.textContent = label;
      elMeta.hidden = false;
    } else {
      elMeta.hidden = true;
    }

    syncAvailability();
    syncQty();
  }

  /* ---------- eventi tema ---------------------------------- */
  document.addEventListener('variant:change', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    setTimeout(function () { sync(variant); }, 0);
  });

  /* delegato: il form puo' essere sostituito dal re-render */
  document.addEventListener('change', function (e) {
    var form = getForm();
    if (form && form.contains(e.target)) setTimeout(function () { sync(null); }, 80);
  });

  document.addEventListener('product:added', function () { setLoading(false); syncAvailability(); });

  /* ---------- inoltro del click al form nativo -------------- */
  var loadingTimer = null;
  elBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (elBtn.disabled || elBtn.classList.contains('is-loading')) return;
    var btn = getNativeBtn();
    if (!btn || btn.disabled) { syncAvailability(); return; }
    if (elQIn && elQty && !elQty.hidden) setQty(elQIn.value);
    setLoading(true);
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(function () { setLoading(false); syncAvailability(); }, 6000);
    btn.click();
  });

  /* ---------- visibilita' ----------------------------------- */
  var showing = false;
  function setVisible(v) {
    if (v === showing) return;
    showing = v;
    root.classList.toggle('is-visible', v);
    /* i pulsanti flottanti di iubenda salgono sopra la barra (sa-cro.css) */
    if (v) document.documentElement.style.setProperty('--sa-sticky-h', (root.offsetHeight || 70) + 'px');
    document.body.classList.toggle('sa-sticky-visible', v);
  }

  /* Visibile quando il pulsante nativo NON e' sullo schermo (sopra o sotto)
     e l'utente ha iniziato a scorrere: all'apertura foto, stelline e titolo
     restano puliti, poi un'azione d'acquisto e' sempre a portata (audit PDP-02).
     Controllo sulla posizione a ogni scroll (throttling con rAF): un
     IntersectionObserver non scatta se uno scroll veloce salta il pulsante. */
  var MIN_SCROLL = 160;
  var sentinel = getSentinel();
  var pending = false;
  function checkVisibility() {
    pending = false;
    if (!sentinel || !document.contains(sentinel)) sentinel = getSentinel();
    if (!sentinel) { setVisible(false); return; }
    var r = sentinel.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var nativeOnScreen = r.bottom > 0 && r.top < vh;
    setVisible(!nativeOnScreen && (window.scrollY || window.pageYOffset) > MIN_SCROLL);
  }
  function scheduleCheck() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(checkVisibility);
  }
  window.addEventListener('scroll', scheduleCheck, { passive: true });
  window.addEventListener('resize', scheduleCheck, { passive: true });

  function refreshSentinel() {
    sentinel = getSentinel();
    scheduleCheck();
  }

  /* Osserva la sezione prodotto (persistente). La callback scrive solo
     dentro la barra sticky, che sta fuori dall'area osservata: nessun loop. */
  var watchRoot = initialForm.closest('.shopify-section') || document.getElementById('main') || document.body;
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refreshSentinel();
      syncAvailability();
    });
  }).observe(watchRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class'] });

  /* nasconde la barra quando il carrello o un popup e' aperto */
  ['rebuy:cart:open', 'cart:open', 'popup:open'].forEach(function (evt) {
    document.addEventListener(evt, function () { root.classList.add('sa-hide'); });
  });
  ['rebuy:cart:close', 'cart:close', 'popup:close'].forEach(function (evt) {
    document.addEventListener(evt, function () { root.classList.remove('sa-hide'); });
  });

  /* Solo in anteprima tema: la barra di Shopify ("Draft", in basso) sta nel top layer e copriva la
     barra fissa. Se c'e', la barra fissa sale sopra di lei; per i clienti non esiste e non cambia nulla. */
  var pbarObserved = null;
  function syncPreviewBar() {
    var w = document.getElementById('PBarNextFrameWrapper');
    var h = (w && w.isConnected && getComputedStyle(w).display !== 'none') ? w.offsetHeight : 0;
    root.style.bottom = h ? h + 'px' : '';
    if (w && pbarObserved !== w && window.ResizeObserver) {
      pbarObserved = w;
      new ResizeObserver(syncPreviewBar).observe(w);
    }
  }
  if (/preview_theme_id|_ab=|_fd=/.test(location.search) || document.cookie.indexOf('preview_theme') !== -1 || window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main') {
    syncPreviewBar();
    new MutationObserver(syncPreviewBar).observe(document.body, { childList: true });
  }

  sync(null);
  checkVisibility();
})();
